var _style, _circle, _g, _circle2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionGreenA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 269.3",
    style: {
      enableBackground: "new 0 0 269.3 269.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.4;fill:url(#SVGID_00000063605597850382774480000014579719921117348244_);}\n\t.st2{fill:url(#SVGID_00000090294533216791457990000003311161487237056921_);}\n\t.st3{opacity:0.16;}\n\t.st4{opacity:0.5;fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st6{opacity:0.5;}\n\t.st7{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6457,
    y1: 6.1615,
    x2: 134.6457,
    y2: 263.1298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6EAF19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#BCFF32"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 134.6,
    cy: 134.6,
    r: 128.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013885832038226193300000017268657027343892133_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.2673,
    y1: 72.2091,
    x2: 116.2673,
    y2: 248.7011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    style: {
      stopColor: "#BCFF32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    style: {
      stopColor: "#6EAF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000013885832038226193300000017268657027343892133_)"
    },
    d: "M142.6,241.4 c-64.2,0-116.2-52-116.2-116.2c0-19.1,4.6-37.1,12.8-53c-11.8,17.9-18.6,39.4-18.6,62.4c0,63,51.1,114.1,114.1,114.1 c29.8,0,57-11.5,77.3-30.2C192.6,232.9,168.6,241.4,142.6,241.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083057866552961085640000010542959238936658353_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6457,
    y1: 6.1615,
    x2: 134.6457,
    y2: 263.1298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007340605,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.0037435
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083057866552961085640000010542959238936658353_)"
    },
    d: "M134.6,6.2C63.7,6.2,6.2,63.7,6.2,134.6 s57.5,128.5,128.5,128.5s128.5-57.5,128.5-128.5S205.6,6.2,134.6,6.2z M134.6,258.9c-68.6,0-124.2-55.6-124.2-124.2 S66,10.4,134.6,10.4S258.9,66,258.9,134.6S203.2,258.9,134.6,258.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 186.4,
    cy: 32.8,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.7,36.9c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C199.4,34,200.7,35.3,200.7,36.9z"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 134.6,
    cy: 134.6,
    r: 131.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 781,
    height: 756,
    xlinkHref: "CBFA8CD.png",
    transform: "matrix(0.24 0 0 0.24 40.8926 46.4126)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.6,77.5h22l46.5,109.4h-25l-9.9-24.4h-45.9l-9.9,24.4H77.1L123.6,77.5z M148.8,141.4l-14.4-35.2 l-14.4,35.2H148.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionGreenA);
export default __webpack_public_path__ + "static/media/option-green-a.338ade0a7e599e32959c788bcad29604.svg";
export { ForwardRef as ReactComponent };